module.exports = __webpack_public_path__ + "./assets/fonts/Montserrat-Light.ttf?409c7f79a42e56c785f50ed37535f0be";